import { useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import QRCodeStyling from "qr-code-styling";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import { useCompanyPreferences } from "../../../Configuration/hooks/usePreferences";
import { getUploadUrl } from "../../../../../utils/helpers/upload";
import { getSubDomainFromDomain } from "../../../../../utils/helpers/url";
import { useMainCompany } from "../../../../../utils/hooks/company";
import { DEFAULT_QR_PRINT_CELLS, QR_PRINT_PREFERENCE_KEY } from "../../../Configuration/QrCode";

const joinLabel = (...parts) => parts.filter(Boolean).join("-");

const formatQrPrintResource = (resource, format) => {
	if (!resource) {
		return "";
	}

	const { code, description, glSegment } = resource;
	switch (format) {
		case "code":
			return code || "";
		case "description":
			return description || "";
		case "glSegment":
			return glSegment || "";
		case "glSegment-description":
			return joinLabel(glSegment, description);
		default:
			return joinLabel(code, description);
	}
};

function ComponentToPrint({ id, location, description, project }) {
	const { t } = useTranslation();
	const company = useMainCompany();
	const { groups } = useGroups();

	// const printConfig = useConfigurationModule(QR_PRINT_PREFERENCE_KEY);
	// const printConfig = undefined; // TODO: clean this
	const printConfig = useCompanyPreferences(QR_PRINT_PREFERENCE_KEY);
	const config = printConfig?.cells || DEFAULT_QR_PRINT_CELLS;
	console.log({ config })

	const group = useMemo(
		() => groups?.find(({ useInClockIn }) => useInClockIn),
		[groups],
	);

	useEffect(() => {
		const subdomain = getSubDomainFromDomain(window.location.hostname);

		const qrCode = new QRCodeStyling({
			width: 700,
			height: 700,
			data: `${window.location.origin}/qr-code-clock-in/${id}`,
			image: "/assets/images/logo_traxxion_min.png",
			dotsOptions: {
				color: "#000",
				type: "rounded",
			},
			imageOptions: {
				crossOrigin: "anonymous",
				margin: 20,
			},
		});
		document.getElementById(`qr-image-${id}`).innerHTML = "";
		qrCode.append(document.getElementById(`qr-image-${id}`));
	}, [id]);

	return (
		<div
			id={`qr-content-${id}`}
			style={{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<div className="d-flex justify-content-center mx-5" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
				<img
					alt=""
					src={
						company?.logo
							? getUploadUrl(company.logo)
							: "/assets/images/logo-traxxion-horizontal.png"
					}
					style={{ maxHeight: 200, maxWidth: 700 }}
				/>
			</div>

			<div style={{ marginTop: 20 }} />

			<div id={`qr-image-${id}`} />

			<div style={{ marginTop: 20 }} />

			<div
				className="w-100 px-5 my-7"
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(3, 1fr)",
					gap: "1.5rem 3rem",
				}}
			>
				{(config).map((cell, index) => {
					const emptyCell = <div key={index} />;
					if (!cell || (!project && (cell.field === "orgLevel" || cell.field === "address"))) {
						return emptyCell;
					}

					let value = "";
					switch (cell.field) {
						case "location": {
							value = formatQrPrintResource(location, cell.format);
							break;
						}
						case "orgLevel": {
							value = formatQrPrintResource(project, cell.format);
							break;
						}
						case "description": {
							value = description;
							break;
						}
						case "address": {
							const { address1, city, state, postalCode } = project;
							value = [address1, city, state, postalCode].filter(Boolean).join(' / ');
							break;
						}
						default: {
							break;
						}
					}
					if (!value) {
						return emptyCell;
					}

					const label = cell.field === "orgLevel"
						? group?.description || t('organization-level')
						: t(cell.field);

					return (
						<div key={index} className="d-flex flex-column align-items-center text-center">
							<h2 className="font-weight-bolder text-dark display-3">
								{label}:
							</h2>

							<h3 className="font-weight-bolder text-dark display-4">
								{value}
							</h3>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default ComponentToPrint;
